function TagFilterBtn({ color = '#333' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-label="태그 필터"
    >
      <desc>태그 필터</desc>
      <defs>
        <clipPath id="5xv1dfq3va">
          <path
            fill="#fff"
            stroke="#707070"
            d="M0 0h24v24H0z"
            data-name="사각형 11461"
            opacity="0.33"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#5xv1dfq3va)" data-name="마스크 그룹 4464">
        <g
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeWidth="1.5"
          data-name="그룹 13614"
          transform="translate(5 5)"
        >
          <path d="M2 0v7.408" data-name="패스 8195"></path>
          <circle
            cx="2"
            cy="2"
            r="2"
            strokeLinejoin="round"
            data-name="타원 1280"
            transform="rotate(90 -1.75 5.75)"
          ></circle>
          <path strokeLinejoin="round" d="M7 6.5V14" data-name="선 241"></path>
          <circle
            cx="2"
            cy="2"
            r="2"
            strokeLinejoin="round"
            data-name="타원 1281"
            transform="rotate(90 3.25 5.75)"
          ></circle>
          <path strokeLinejoin="round" d="M12 0v7.5" data-name="선 242"></path>
          <circle
            cx="2"
            cy="2"
            r="2"
            strokeLinejoin="round"
            data-name="타원 1282"
            transform="rotate(90 3.25 10.75)"
          ></circle>
          <path
            strokeLinejoin="round"
            d="M12 11.5V14"
            data-name="선 243"
          ></path>
          <path strokeLinejoin="round" d="M7 0v2.5" data-name="선 244"></path>
          <path d="M2 11.5V14" data-name="패스 8196"></path>
        </g>
      </g>
    </svg>
  )
}

export default TagFilterBtn
